import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';



//SCROLL THE PAGE FUNCTION

function ScrollToTopOnPageChange() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default ScrollToTopOnPageChange;
